import {instance as axios} from '../jslib/HttpRequest'
import qs from 'qs'
// 获取详情
function userMessage(obj){
	return new Promise((resolve,reject)=>{
		axios({
			url:'common/showUserInfoByCode',
			method: 'POST',
			data:obj

		})
		.then((response)=>{
            resolve(response)
		})
		.catch((error)=>{
			console.log(error)
      reject(error)
		})
	})
}
//
// 确认无误
function confirmId(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'common/confirmId',
      method: 'POST',
      data:obj

    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 获取图形验证码
function getCodeImg(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'signCode/getCode',
      method: 'POST',
      data:obj,
      responseType:'blob'

    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 获取手机验证码
function getCodePhone(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'common/getCode',
      method: 'POST',
      data:obj,
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 上传图片
function getImgUrl(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/file/upload',
      method: 'post',
      data:obj,

    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 身份证ocr识别
function idOrc(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/userCertification/iDCardOCR',
      method: 'post',
      data:obj,

    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 查询是否能报名及地区任务是否存在
function ifRegister(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/attendance/selectStatus',
      method: 'post',
      data:obj,

    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 获取图形验证码2
function getCodeImg2(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/signCode/getCodeTelePhone',
      method: 'POST',
      data:obj,
      responseType:'blob'

    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 获取手机验证码
function getCodePhone2(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/attendance/getAuthCode',
      method: 'POST',
      data:obj,
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 检验手机验证码
function buildingPhone(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/attendance/examinationAuthCode',
      method: 'POST',
      data:obj,
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// h5注册或者报名
function register(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/attendance/register',
      method: 'POST',
      data:obj,
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
// 获取用户信息
function selectByExample(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/users/selectUsesAndUserbank',
      method: 'GET',
      params:obj,
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
//修改银行卡
function resetBank(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/users/updateUsesAndUserbank',
      method: 'POST',
      data:obj,
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
//修改银行卡
// function print(obj){
//   return new Promise((resolve,reject)=>{
//     axios({
//       url:'https://api.feieyun.cn/Api/Open/',
//       method: 'POST',
//       data:qs.stringify(obj),
//       headers:{
//         "content-type": "application/x-www-form-urlencoded"
//       }
//     })
//       .then((response)=>{
//         resolve(response)
//       })
//       .catch((error)=>{
//         console.log(error)
//         reject(error)
//       })
//   })
// }
//银行卡识别
function bankCardOcr(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'common/bankCardOcr',
      method: 'POST',
      data:obj,
      // data:qs.stringify(obj),
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
//通过其中一个便利店编码查询用户的所有便利店
function allConvenienceNo(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'mallCommission/selectConvenienceNo',
      method: 'get',
      params:obj,
      // data:qs.stringify(obj),
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
//查询该便利所有账期
function selectBillMonth(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'mallCommission/selectBillMonth',
      method: 'get',
      params:obj,
      // data:qs.stringify(obj),
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
//查询用户法大大认证状态
function showUserAuthentication(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/common/showUserAuthentication',
      method: 'post',
      data:obj,
      // data:qs.stringify(obj),
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
//查询用户法大大认证状态
function showUserAuthentication(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/common/showUserAuthentication',
      method: 'post',
      data:obj,
      // data:qs.stringify(obj),
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
//获取和同手机验证码
function getFddCode(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/common/getCode',
      method: 'post',
      data:obj,
      // data:qs.stringify(obj),
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
//获取和同手机验证码
function checkFddCode(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/common/checkCode',
      method: 'post',
      data:obj,
      // data:qs.stringify(obj),
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}

//查询是否签约
function checkSign(obj){
  return new Promise((resolve,reject)=>{
    axios({
      url:'/common/queryUserSignStatus',
      method: 'get',
      params:obj,
      // data:qs.stringify(obj),
    })
      .then((response)=>{
        resolve(response)
      })
      .catch((error)=>{
        console.log(error)
        reject(error)
      })
  })
}
export  {
  userMessage,
  confirmId,
  getCodeImg,
  getCodePhone,
  getImgUrl,
  idOrc,
  ifRegister,
  getCodeImg2,
  getCodePhone2,
  buildingPhone,
  register,
  selectByExample,
  resetBank,
  bankCardOcr,
  allConvenienceNo,
  selectBillMonth,
  showUserAuthentication,
  getFddCode,
  checkFddCode,
  checkSign
}





// WEBPACK FOOTER //
// ./src/server/allServer.js